export default __webpack_public_path__ + "static/media/photo4.ce987913.png";